// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__3n3Ne","inner":"Sidebar_inner__1LyLi"};